"use strict";

exports.__esModule = true;
exports.PLANT_SETTINGS_URL = void 0;
exports.PredefinedCommentsController = PredefinedCommentsController;
var _equals2 = _interopRequireDefault(require("ramda/src/equals"));
var _react = _interopRequireWildcard(require("react"));
var _RestAPI = require("../../API/RestAPI");
var _UI = require("../../../Utils/UI");
var _Core = require("../../Core");
var _excluded = ["__v"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t2 in e) "default" !== _t2 && {}.hasOwnProperty.call(e, _t2) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t2)) && (i.get || i.set) ? o(f, _t2, i) : f[_t2] = e[_t2]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var PLANT_SETTINGS_URL = exports.PLANT_SETTINGS_URL = "/api/v1/plant/plant-settings";
function PredefinedCommentsController(_ref) {
  var children = _ref.children;
  var api = (0, _react.useContext)(_RestAPI.RestAPIContext);
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var options = (0, _react.useMemo)(function () {
    return {
      method: "GET"
    };
  }, []);
  var _useState = (0, _react.useState)(DEFAULT_SETTINGS),
    settings = _useState[0],
    setSettings = _useState[1];
  var _useState2 = (0, _react.useState)(DEFAULT_SETTINGS),
    oldSettings = _useState2[0],
    setOldSettings = _useState2[1];
  var _useRestApi = (0, _RestAPI.useRestApi)({
      url: PLANT_SETTINGS_URL,
      options: options,
      formatDataProps: {
        formatFn: function formatFn(retrievedData) {
          return [retrievedData];
        },
        shouldFormat: true
      }
    }),
    loading = _useRestApi.loading,
    data = _useRestApi.data;
  (0, _react.useEffect)(function () {
    var apiSettings = (data == null ? void 0 : data[0]) || settings;
    setSettings(apiSettings);
    setOldSettings(apiSettings);
  }, [data]);
  var methods = (0, _react.useMemo)(function () {
    return {
      addComment: function addComment(comment) {
        setSettings(function (settings) {
          return Object.assign({}, settings, {
            defaultComments: settings.defaultComments.concat([{
              comment: comment
            }])
          });
        });
      },
      deleteComment: function deleteComment(index) {
        setSettings(function (settings) {
          var newComments = settings.defaultComments.slice();
          newComments.splice(index, 1);
          return Object.assign({}, settings, {
            defaultComments: newComments
          });
        });
      },
      setComment: function setComment(id, comment) {
        setSettings(function (settings) {
          var newComments = settings.defaultComments.slice();
          newComments[id] = comment;
          return Object.assign({}, settings, {
            defaultComments: newComments
          });
        });
      },
      updateSettings: function () {
        var _updateSettings = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(settings) {
          var __v, restSettings, updatedSettings, _t;
          return _regenerator().w(function (_context) {
            while (1) switch (_context.p = _context.n) {
              case 0:
                _context.p = 0;
                __v = settings.__v, restSettings = _objectWithoutPropertiesLoose(settings, _excluded);
                _context.n = 1;
                return api.put(PLANT_SETTINGS_URL, restSettings);
              case 1:
                updatedSettings = _context.v;
                setSettings(updatedSettings);
                (0, _UI.showSuccessToaster)(translate("PredefinedCommentsScreen.UpdateToaster.Success", "Updated plant settings successfully"));
                _context.n = 3;
                break;
              case 2:
                _context.p = 2;
                _t = _context.v;
                (0, _UI.showErrorToaster)(translate("PredefinedCommentsScreen.UpdateToaster.Error", "Plant Settings update failed"));
              case 3:
                return _context.a(2);
            }
          }, _callee, null, [[0, 2]]);
        }));
        function updateSettings(_x) {
          return _updateSettings.apply(this, arguments);
        }
        return updateSettings;
      }()
    };
  }, []);
  return children(Object.assign({}, methods, {
    loading: loading,
    settings: settings,
    unchanged: (0, _equals2["default"])(settings, oldSettings)
  }));
}
var DEFAULT_SETTINGS = {
  defaultComments: []
};